// Textos que se escriben igual en los dos idiomas
export const IGUALES = [
 "&excluir={cargaId}",
 "+1XXXXXXXXXX",
 "1 PM",
 "5 AM",
 "9 PM",
 "Chassis",
 "Chassis return J1",
 "Chassis: {chasis_numero}",
 "Chicago (CT)",
 "DO · PDF",
 "Delivery",
 "Delivery Order",
 "Denver (MT)",
 "Dispatch",
 "Drop",
 "Empty return J1",
 "Error",
 "General",
 "LEONA’S GROUP",
 "Live unload",
 "No",
 "No address on file",
 "OK",
 "Pick up chassis",
 "Pickup receipt",
 "Rail pickup",
 "Rail pickup receipt",
 "Return chassis",
 "Return empty container",
 "Signed DO / POD",
 "WhatsApp",
 "Yard stop",
 "ZIP",
 "correo@empresa.com",
 "estado-us",
 "main h1",
 "papeles_{numero_contenedor}.pdf",
 "plantilla_{tipo}.csv",
 "reporte_{reporte_tipo}.pdf",
 "reporte_{tipo}_{desde}_{hasta}.pdf",
 "ticket",
 "zip",
 "{v0} gal"
];
